import { withInstall } from '@lit-element/utils'
import Tooltip from './src/tooltip.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtTooltip: SFCWithInstall<typeof Tooltip> = withInstall(Tooltip)
export * from './src/tooltip'
export * from './src/trigger'
export * from './src/content'
export * from './src/constants'
export default LtTooltip
